<template>
  <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="data"
      :footer-props="{
        disableItemsPerPage: true,
        itemsPerPageText: '',
        itemsPerPageOptions: [],
        disablePagination: true
      }"
  >
    <template v-slot:[`item.triggeredFromNetTraffic`]="{ item }">
      <td>
        <strategy-report-value :value="item.triggeredFromNetTraffic" breakpoint="20" />
      </td>
    </template>
    <template v-slot:[`item.conversionToolEnqFromUniqueNetTraffic`]="{ item }">
      <td>
        <strategy-report-value :value="item.conversionToolEnqFromUniqueNetTraffic" breakpoint="0.1" />
      </td>
    </template>
  </v-data-table>
</template>

<script>
import StrategyReportValue from "@/components/HealthScore/StrategyReport/StrategyReportValue.vue";

export default {
  name: "StrategyReportTable",
  components: {StrategyReportValue},
  data: () => ({
    headers: [
      {text: 'Campaign Name', value: 'campaignName'},
      {text: 'Triggered from Net Traffic', value: 'triggeredFromNetTraffic'},
      {text: 'Conversion Tool Enq from Unique Net Traffic', value: 'conversionToolEnqFromUniqueNetTraffic'},
    ],
  }),
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>

</style>